import { env } from '@/config/env';
import { useI18n } from '@/i18n/context';
import { isApproved, type ContentSection } from './contentStatus';
import styles from './DraftMarker.module.css';

/** Discreet review marker for unapproved copy (hidden in production). */
export function DraftMarker({ section, tone = 'light' }: { section: ContentSection; tone?: 'light' | 'dark' }) {
  const { t } = useI18n();
  if (!env.showContentStatus || isApproved(section)) return null;
  return (
    <span className={[styles.marker, tone === 'dark' ? styles.dark : ''].join(' ')} data-content-section={section}>
      {t.common.status.draftContent}
    </span>
  );
}
